module.exports = __webpack_public_path__ + "img/school_supplies_final.d31e0f7f.png";